import { useMemo, useState } from "react";
import {
  isMaterialUsageRecorded,
  isSupplyRecordingClosed,
  type MaterialUsage,
} from "./serviceMaterials";

export function useFinishedSuppliesFilter<Usage extends MaterialUsage>(
  materials: Usage[],
  ticketStatus: string | null | undefined
) {
  const [showUnused, setShowUnused] = useState(false);
  const recordingClosed = isSupplyRecordingClosed(ticketStatus);
  const unusedCount = useMemo(
    () => materials.filter((usage) => !isMaterialUsageRecorded(usage)).length,
    [materials]
  );
  const visibleMaterials = useMemo(
    () =>
      recordingClosed && !showUnused
        ? materials.filter(isMaterialUsageRecorded)
        : materials,
    [materials, recordingClosed, showUnused]
  );

  return {
    recordingClosed,
    visibleMaterials,
    unusedCount,
    showUnused,
    setShowUnused,
  };
}
